export const APP_STORE_URL = 'https://apps.apple.com/app/id6805807663';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=kr.postpop.app';

export function mobileStoreUrl(nav = navigator) {
  if (/android/i.test(nav.userAgent)) return PLAY_STORE_URL;
  if (
    /iPad|iPhone|iPod/i.test(nav.userAgent) ||
    (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1)
  )
    return APP_STORE_URL;
  return null;
}

// Browsers cannot reliably query installation. Cancel the fallback as soon as
// the app takes over, including when the user later returns to this page.
export function openAppWithStoreFallback(
  appUrl,
  { win = window, doc = document, nav = navigator } = {},
) {
  const store = mobileStoreUrl(nav);
  let timer;
  const cancel = () => {
    win.clearTimeout(timer);
    doc.removeEventListener('visibilitychange', onVisibility);
    win.removeEventListener('pagehide', cancel);
  };
  const onVisibility = () => {
    if (doc.visibilityState === 'hidden') cancel();
  };
  if (store) {
    doc.addEventListener('visibilitychange', onVisibility);
    win.addEventListener('pagehide', cancel);
    timer = win.setTimeout(() => {
      const visible = doc.visibilityState !== 'hidden';
      cancel();
      if (visible) win.location.assign(store);
    }, 1800);
  }
  win.location.assign(appUrl);
  return cancel;
}
